import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[scipWhitespaceValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: WhitespaceValidatorDirective, multi: true }]
})
export class WhitespaceValidatorDirective implements Validator {
  static whitespace(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.length > 0 && control.value.toString().trim() === '') {
      return { whitespace: { value: control.value } };
    } else {
      return null;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return WhitespaceValidatorDirective.whitespace(control);
  }
}
